var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('div',{staticClass:"container-sm mt-5 privacy"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacy.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }